/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {ParameterModelDocument} from '../../../../model/parameter.model'
import {getParametersService} from '../../../../services/parameter.service'
import {useCentralServices} from '../../../../../hoteleria/hooks/useCentralServices'
import {SelectOption} from '../../../../../../models/utility.model'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'

const TableParameters: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [sites, setSites] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [parameterStatus, setParameterStatus] = useState<SelectOption[]>([])
  const [moneda, setMoneda] = useState<SelectOption[]>([])
  const [applications, setApplications] = useState<SelectOption[]>([])
  const [parameterUnidad, setParameterUnidad] = useState<SelectOption[]>([])

  const {
    getCompanies,
    getClients,
    getParametersStatus,
    getMoneda,
    getUnidadParameter,
    getApplications,
    getSites,
    getCamps,
  } = useCentralServices()

  const getParametersList = async () => {
    try {
      setLoading(true)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
      const {data: response} = await getParametersService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    setClient(data)
  }

  const getSitesFn = async () => {
    const data = await getSites({isCombo: true}, 1)
    setSites(data)
  }

  const getCampamentFn = async () => {
    const data = await getCamps({isCombo: true}, 1)
    setCamps(data)
  }

  const getApplicationsFn = async () => {
    const data = await getApplications()
    setApplications(data)
  }

  const getParametersStatusFn = async () => {
    const data = await getParametersStatus()
    setParameterStatus(data)
  }

  const getMonedaFn = async () => {
    const data = await getMoneda()
    setMoneda(data)
  }

  const getUnidadParameterFn = async () => {
    const data = await getUnidadParameter()
    setParameterUnidad(data)
  }

  useEffect(() => {
    getCompaniesFn()
    getClientsFn()
    getSitesFn()
    getCampamentFn()
    getParametersStatusFn()
    getMonedaFn()
    getUnidadParameterFn()
    getApplicationsFn()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getParametersList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])
  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getParametersList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.Id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-parameters',
      },
      idToDelete: '',
      objectInfo: {
        aplicacion: getData.Aplicacion_descripcion,
        aplicacionId: getData.AplicacionId,
        RangoCabId: getData.RangoCabId,
      },
      editOnBottomPanel: true,
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<ParameterModelDocument>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Código' name={'Codigo'} searcheable />
        ),
        accessor: 'Codigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={compani}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={sites} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name={'CampamentoId'}
            selecteable
            data={camps}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Módulo'
            name={'AplicacionId'}
            selecteable
            data={applications}
          />
        ),
        accessor: 'Aplicacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Inicio' name={'FechaIni'} dateable />
        ),
        accessor: 'FechaIni',
        Cell: ({...props}) => <div>{formatDateDDMMYYYY(props.row.original.FechaIni)}</div>,
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin' name={'FechaFin'} dateable />
        ),
        accessor: 'FechaFin',
        Cell: ({...props}) => <div>{formatDateDDMMYYYY(props.row.original.FechaFin)}</div>,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name={'EstadoParametrosId'}
            selecteable
            data={parameterStatus}
          />
        ),
        accessor: 'EstadoParametros_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Moneda'
            name={'MonedaId'}
            selecteable
            data={moneda}
          />
        ),
        accessor: 'Moneda_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Unidad'
            name={'UnidadParametrosId'}
            selecteable
            data={parameterUnidad}
          />
        ),
        accessor: 'UnidadParametros_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}{' '}
          </>
        ),
      },
    ],
    [compani, client, sites, applications, parameterStatus, parameterUnidad, moneda, selectedOn],
  )

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getParametersList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getParametersList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
      setClient([])
      setSites([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      <KTCard shadow className=' w-100'>
        <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableParametersWrapper = () => {
  return (
    <KTableProvider>
      <TableParameters />
    </KTableProvider>
  )
}

export {TableParametersWrapper}
